export default __webpack_public_path__ + "static/media/placeholder-banner-min.9198855a.png";